export default __webpack_public_path__ + "static/media/idea-crov-fly-animation.2c9a80b6.gif";